import { Navigate, useSearchParams } from 'react-router-dom';
import { Loader2, Grid3X3 } from 'lucide-react';
import PlayView from './PlayView';
import { useAppEntryRedirect } from '../hooks/useAppEntryRedirect';

/**
 * PlayTabView
 *
 * - If `contestId` is present in query params, render the Squares grid (`PlayView`)
 * - Otherwise use app entry redirect logic to send user to PlayView (with contest) or ResultsView
 */
export default function PlayTabView() {
  const [searchParams] = useSearchParams();
  const contestId = searchParams.get('contestId');
  const { result, isLoading } = useAppEntryRedirect({ enabled: !contestId });

  if (contestId) {
    return <PlayView key={contestId} />;
  }

  if (isLoading) {
    return (
      <div className="px-4 py-8 flex flex-col items-center justify-center min-h-[400px]">
        <Loader2 className="w-8 h-8 animate-spin text-[#53d337] mb-4" />
        <p className="text-zinc-400">Loading...</p>
      </div>
    );
  }

  if (result && !result.showRulesView && result.redirectTo.path === '/play') {
    const { contestId, mode } = result.redirectTo;
    const query =
      mode === 'results' ? `contestId=${contestId}&mode=results` : `contestId=${contestId}`;
    return <Navigate to={`/play?${query}`} replace />;
  }

  // No active or pending contests — show empty state instead of navigating away
  if (result && !result.showRulesView && result.redirectTo.path === '/results') {
    return (
      <div className="px-4 py-8 flex flex-col items-center justify-center min-h-[400px]">
        <div className="w-20 h-20 rounded-full bg-zinc-800 flex items-center justify-center mb-4">
          <Grid3X3 className="w-10 h-10 text-zinc-600" />
        </div>
        <h2 className="text-white font-semibold text-lg mb-2">No Contests at the Moment</h2>
        <p className="text-zinc-500 text-sm text-center max-w-xs">Please come back later.</p>
      </div>
    );
  }

  return <Navigate to="/" replace />;
}
